import * as React from "react";
import styled, { keyframes } from "styled-components";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import PlayedCard from "./Types/PlayedCard";

const hideLogMessage = keyframes`
	0% {
        opacity: 1;
	}
	99% {
        opacity: 0;
        position: initial;
        bottom: initial;
	}
	100% {
        opacity: 0;
        position: absolute;
        bottom: -100px;
	}
`;
interface Props {
  playedCards: PlayedCard[];
  activePlayerName: string;
}

const LogMessage = styled.div`
  color: white;
  background: #80805c;
  padding: 2em;
  border-radius: 0.4em;
  margin: 0.5em 1em;
  color: white;
  max-width: 100%;
`;

const StyledLog = styled.div`
  height: 100vh;
  max-height: 100vh;
  width: 100%;
  width: 30rem;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: -1;
  box-sizing: border-box;
  display: flex;
  align-items: flex-end;
  overflow: hidden;

  .item-enter {
    opacity: 0;
  }
  .item-enter-active {
    opacity: 1;
    transition: opacity 500ms ease-in;
  }
  .item-enter-done {
    animation: ${hideLogMessage} 0.5s linear forwards;
    animation-delay: 5s;
  }
`;

const Log = ({ playedCards = [], activePlayerName }: Props) => {
  const [isAnimatingLogMessages, setIsAnimatingLogMessages] =
    React.useState(false);

  // Workaround to have <TransitionGroup /> animate the initial set of played cards
  // (happens when rejoining an existing game)
  React.useEffect(() => {
    setIsAnimatingLogMessages(true);
  }, []);

  let cardsToAnimate: PlayedCard[] = [];

  if (isAnimatingLogMessages) {
    cardsToAnimate = playedCards;
  }

  return (
    <StyledLog>
      <TransitionGroup>
        {cardsToAnimate.map(({ playedCard, pileIndex }) => (
          <CSSTransition key={playedCard} timeout={500} classNames="item">
            {(state) => <LogMessage>Card {playedCard} was played.</LogMessage>}
          </CSSTransition>
        ))}
      </TransitionGroup>
    </StyledLog>
  );
};

export default Log;
